import type { ProductTaxonomyRenameDefinition } from '../types';

export const reportsRename = {
  copy: {
    'nav.review.analysis': {
      current: 'Analysis',
      future: 'Reports',
    },
    'analysis.pageTitle': {
      current: 'Analysis',
      future: 'Reports',
    },
  },
  routes: {
    'analysis.index': {
      current: '/workspaces/:workspaceId/journeys/analysis',
      future: '/workspaces/:workspaceId/journeys/reports',
    },
    // The Deliverability and Email clients tabs are Hydra-owned pages, so they sit off
    // `/workspaces/:workspaceId` directly with no `/journeys` segment. They still belong to
    // this rename: their vocabulary follows the parent page from `analysis` to `reports`.
    'analysis.deliverability': {
      current: '/workspaces/:workspaceId/analysis/deliverability',
      future: '/workspaces/:workspaceId/reports/deliverability',
    },
    'analysis.emailClients': {
      current: '/workspaces/:workspaceId/analysis/email-clients',
      future: '/workspaces/:workspaceId/reports/email-clients',
    },
  },
  sideNavItemIds: {
    analysis: 'reports',
  },
} as const satisfies ProductTaxonomyRenameDefinition;
